import CitySEOHead from "@/components/feature/CitySEOHead";
import DouglasvilleHeroSection from "./components/HeroSection";
import DouglasvilleStickyNav from "./components/StickyNav";
import DouglasvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import DouglasvilleServicesSection from "./components/ServicesSection";
import DouglasvilleLocalAreaSection from "./components/LocalAreaSection";
import DouglasvilleTestimonialsSection from "./components/TestimonialsSection";
import DouglasvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import DouglasvilleComparisonSection from "./components/ComparisonSection";
import DouglasvilleMistakesSection from "./components/MistakesSection";
import DouglasvilleHowItWorksSection from "./components/HowItWorksSection";
import DouglasvilleFAQSection, { faqs } from "./components/FAQSection";
import DouglasvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import DouglasvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function DouglasvillePage() {
  return (
    <>
      <CitySEOHead
        city="Douglasville"
        state="Georgia"
        stateAbbr="GA"
        route="/cities/douglasville"
        title="Emergency Passport Douglasville, GA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Douglasville, GA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Douglas County and west metro Atlanta travelers. Get your emergency passport fast!"
        geoPlacename="Douglasville, Georgia"
        geoPosition="33.7515;-84.7477"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Georgia"
        statePageRoute="/states/georgia"
        keywords="expedited passport, emergency passport, Douglasville passport, same day passport Douglasville, fast passport Georgia, Douglas County passport"
      />
      <div className="font-sans">
        <DouglasvilleHeroSection />
        <DouglasvilleStickyNav />
        <DouglasvilleProcessingTimeSection />
        <DouglasvilleServicesSection />
        <DouglasvilleLocalAreaSection />
        <DouglasvilleTestimonialsSection />
        <DouglasvilleAcceptanceFacilitiesSection />
        <DouglasvilleComparisonSection />
        <DouglasvilleMistakesSection />
        <DouglasvilleHowItWorksSection />
        <DouglasvilleFAQSection />
        <DouglasvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/douglasville" state="GA" />
        <DouglasvilleFinalCTA />
      </div>
    </>
  );
}